import { useId } from 'react';

export function AppIcon() {
  const linearGradientId = useId();
  return (
    <svg
      width="36"
      height="36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 351.65 351.65"
      data-testid="app-icon"
    >
      <defs>
        <style type="text/css">
          {`
            .cls-1, .cls-2 {
              fill: none;
            }

            .cls-2 {
              strokeMiterlimit: 10;
              strokeWidth: 9.9px;
            }

            .cls-2, .cls-3, .cls-4 {
              stroke: #fff;
            }

            .cls-8 {
              fill: #fff;
            }

            .cls-9, .cls-3, .cls-4 {
              fill: #22333b;
            }

            .cls-3 {
              strokeWidth: 15.7px;
              strokeLinejoin: round;
            }

            .cls-4 {
              strokeLinejoin: round;
              strokeWidth: 6.7px;
            }
          `}
        </style>
        <linearGradient
          id={linearGradientId}
          x1="52.44"
          y1="85.16"
          x2="283.5"
          y2="305.12"
          gradientTransform="translate(0 378.7) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00857d" />
          <stop offset="0" stopColor="#088a82" />
          <stop offset=".2" stopColor="#1d9990" />
          <stop offset=".3" stopColor="#41b0a6" />
          <stop offset=".4" stopColor="#64c8bd" />
          <stop offset=".5" stopColor="#4bb0c0" />
          <stop offset=".8" stopColor="#1a81c6" />
          <stop offset="1" stopColor="#0870c9" />
        </linearGradient>
      </defs>
      <g>
        {/* Main outer shape with gradient fill - fill is set using the style attribute */}
        <path
          style={{ fill: `url(#${linearGradientId})` }}
          d="M169.45,22.65c88.1,0,159.5,71.4,159.5,159.5s-71.4,159.5-159.5,159.5S9.95,270.25,9.95,182.15,81.35,22.65,169.45,22.65h0Z"
        />
        {/* Inner white circle */}
        <circle className="cls-8" cx="169.45" cy="182.15" r="140.4" />
      </g>
      {/* Transparent Rectangle (using className="cls-1") */}
      <rect className="cls-1" x="17.85" y="12.25" width="303.3" height="313.6" />
      {/* Outer stroke ring (using className="cls-2") */}
      <circle className="cls-2" cx="169.45" cy="182.15" r="164.5" />
      <g>
        {/* Internal polygons forming the abstract shape (using className="cls-9") */}
        <polygon
          className="cls-9"
          points="212.15 135.25 180.85 249.35 158.05 191.75 212.15 135.25"
        />
        <polygon
          className="cls-9"
          points="212.15 135.25 99.55 171.45 158.05 191.75 212.15 135.25"
        />
      </g>
      {/* The star/diamond element to the right of the circle (using className="cls-3") */}
      <polygon
        className="cls-3"
        points="326.15 70.95 324.45 69.95 322.65 69.05 320.45 67.85 301.85 57.75 290.55 36.85 289.55 35.15 274.85 7.85 274.85 7.85 260.05 35.15 259.15 36.95 247.85 57.75 228.15 68.35 226.95 69.05 225.25 69.95 223.35 70.95 197.95 84.75 222.75 98.15 225.25 99.45 226.95 100.45 247.85 111.75 257.35 129.35 259.15 132.55 260.05 134.35 260.85 135.85 274.85 161.65 288.35 136.65 289.55 134.35 290.55 132.55 291.75 130.25 301.85 111.75 320.45 101.65 322.65 100.45 324.45 99.45 327.05 98.05 351.65 84.75 326.15 70.95"
      />
    </svg>
  );
}
